/* global axios */
import ApiClient from './ApiClient';

class PromptsAPI extends ApiClient {
  constructor() {
    super('prompts', { accountScoped: true });
  }

  get(promptType = null, format = null) {
    const params = { ...(promptType ? { prompt_type: promptType } : {}) };
    if (format) {
      params.format = format;
    }
    return axios.get(this.url, { params });
  }

  create(data, format = null) {
    const params = format ? { format } : {};
    return axios.post(this.url, { prompt: data }, { params });
  }

  update(id, data, format = null) {
    const params = format ? { format } : {};
    return axios.patch(`${this.url}/${id}`, { prompt: data }, { params });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getDefault(promptType = 'summarization', format = null) {
    const params = {
      prompt_type: promptType,
      ...(format ? { format } : {}),
    };
    return axios.get(`${this.url}/default`, { params });
  }

  preview(data) {
    return axios.post(`${this.url}/preview`, { prompt: data });
  }

  getCustomTemplates() {
    return axios.get(`${this.url}/custom_templates`);
  }
}

export default new PromptsAPI();
